/*
 * This file can be replaced during build by using the `fileReplacements` array.
 * `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
 * The list of file replacements can be found in `angular.json`.
 */
import { EnvironmentBase } from './environment.base';
import { LogLevel } from '@core/logging';

export const environment: EnvironmentBase = {
  production: false,
  logLevel: LogLevel.All,
  hmr: false,
  aadAuthorityDomain: 'pasmb2cdev.b2clogin.com',
  aadClientId: '4d7dd02b-e133-40e6-96a7-e6bd2283c10f',
  aadEditprofileUrl:
    'https://pasmb2cdev.b2clogin.com/pasmb2cdev.onmicrosoft.com/B2C_1_PasswordReset',
  aadScope: 'https://pasmb2cdev.onmicrosoft.com/pasm-edb-api-dev/API.Access',
  aadSignupSigninUrl:
    'https://pasmb2cdev.b2clogin.com/pasmb2cdev.onmicrosoft.com/B2C_1A_SOCIAL_SIGNIN_KPT',
  aadGroupPrefix: 'EDB-DEV',
  baseUrl: 'https://pasm-edb-api-dev.pasmapps.de',
  reports: {
    actualTarget:
      'https://app.powerbi.com/reportEmbed?reportId=6a441df1-0346-4435-8fae-1fe2ceae0399&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    bhkw: 'https://app.powerbi.com/reportEmbed?reportId=d33ff193-e48c-4a11-a923-f720787680c2&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    energyDevelopment:
      'https://app.powerbi.com/reportEmbed?reportId=68325f82-0168-4512-888e-90a4684d1da0&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    generalReport:
      'https://app.powerbi.com/rdlEmbed?reportId=3c15dc3e-4ea6-4793-8355-22de7e7d4800&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4&experience=power-bi',
    importStatus:
      'https://app.powerbi.com/reportEmbed?reportId=8df2c340-d328-4237-9077-cdf6aa38a748&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    loadProfile:
      'https://app.powerbi.com/reportEmbed?reportId=693f191c-e3bd-42da-9dcb-aecbd8d41afa&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    materials:
      'https://app.powerbi.com/reportEmbed?reportId=c8fb86eb-1b98-4dff-a308-872870e3bf53&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    meterReading:
      'https://app.powerbi.com/reportEmbed?reportId=e6c770a7-285b-4dda-9965-990f1f32b26d&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    objectConsumption:
      'https://app.powerbi.com/reportEmbed?reportId=58112400-d927-4e28-bf9d-89f24480d2ba&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    overviewTotal:
      'https://app.powerbi.com/reportEmbed?reportId=7f1a5ac4-7c37-4cd0-998b-0db04ab22b17&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    overviewSmp:
      'https://app.powerbi.com/reportEmbed?reportId=fca5afc4-8fd7-438b-b998-18adf0854174&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    profileAnalysis:
      'https://app.powerbi.com/reportEmbed?reportId=83273911-5ae5-4ebe-addf-9a8e5d2282d3&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    profilePv:
      'https://app.powerbi.com/reportEmbed?reportId=fc4d15e7-e74f-46d4-a993-7f978ad2c2b0&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    pue: 'https://app.powerbi.com/reportEmbed?reportId=0e1ab48e-5013-4419-83ef-25f6b0533299&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    smops:
      'https://app.powerbi.com/reportEmbed?reportId=38bde205-3266-488d-8d88-86593212bc01&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    totalLoad:
      'https://app.powerbi.com/reportEmbed?reportId=ae5e0abc-c4d7-4a0d-87d8-53acab10fef2&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    zeroHourLoad:
      'https://app.powerbi.com/reportEmbed?reportId=595503ab-b182-4331-8cfb-ed0f5c7bbf4f&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
  },
  spaUrl: 'https://pasm-spa-portal-frontend-dev.pasmapps.de',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
